// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 開閉アニメーション用 */
.MasterManager_collapsible__WwFIw {
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.3s;
  max-height: 0;
  opacity: 0;
  pointer-events: none;
}
.MasterManager_collapsible__WwFIw.MasterManager_open__fT8IN {
  max-height: 1000px;
  opacity: 1;
  pointer-events: auto;
}
/* MasterManager用のスタイル。Settings.module.cssからコピー */
.MasterManager_form__XSfQD {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}
.MasterManager_input__GAERA {
  flex: 1 1;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.MasterManager_button__e1moE {
  padding: 4px 12px;
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.MasterManager_brandList__12Xe3 {
  list-style: none;
  padding: 0;
  margin: 0;
}
.MasterManager_brandItem__WMcs0 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 1px solid #eee;
}
.MasterManager_deleteButton__puC2I {
  background: #e53935;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 2px 8px;
  cursor: pointer;
  margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/MasterManager/MasterManager.module.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,gBAAgB;EAChB,mEAAmE;EACnE,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;AACA,iDAAiD;AACjD;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* 開閉アニメーション用 */\r\n.collapsible {\r\n  overflow: hidden;\r\n  transition: max-height 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.3s;\r\n  max-height: 0;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n.collapsible.open {\r\n  max-height: 1000px;\r\n  opacity: 1;\r\n  pointer-events: auto;\r\n}\r\n/* MasterManager用のスタイル。Settings.module.cssからコピー */\r\n.form {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 12px;\r\n}\r\n.input {\r\n  flex: 1;\r\n  padding: 4px 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n.button {\r\n  padding: 4px 12px;\r\n  background: #1976d2;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n.brandList {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.brandItem {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 4px 0;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n.deleteButton {\r\n  background: #e53935;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 2px 8px;\r\n  cursor: pointer;\r\n  margin-left: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapsible": `MasterManager_collapsible__WwFIw`,
	"open": `MasterManager_open__fT8IN`,
	"form": `MasterManager_form__XSfQD`,
	"input": `MasterManager_input__GAERA`,
	"button": `MasterManager_button__e1moE`,
	"brandList": `MasterManager_brandList__12Xe3`,
	"brandItem": `MasterManager_brandItem__WMcs0`,
	"deleteButton": `MasterManager_deleteButton__puC2I`
};
export default ___CSS_LOADER_EXPORT___;
